import { get } from 'lodash';
import React from 'react';
import { ART_DES_ANTRAGS, KOSTEN_ARTEN, KOSTEN_POSITION, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import {
	checkIfAllPositionIsEditable,
	checkIfAnyPositionNachKostenArtHasComment,
	checkIfHasComment,
	checkIfProjektDatenHasComment,
} from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import { TreeStructureAntragAbschlussSeiteGlobal } from '../../global-structure/abschluss-seite/TreeStructureAbschlussSeiteGlobal';
import { TreeStructureAllgemeinHinweisGlobal } from '../../global-structure/allgemeinen-hinweis/TreeStructureAllgemeinHinweisGlobal';
import { TreeStructureAnlagenGlobal } from '../../global-structure/anlagen/TreeStructureAnlagenGlobal';
import { TreeStructureAntragBescheidGlobal } from '../../global-structure/antrag-bescheid/TreestructureAntragBescheidGlobal';
import { TreeStructureAntragstellerGlobal } from '../../global-structure/antragstellerin/TreeStructureAntragstellerGlobal';
import { TreeStructureDeMinimisGlobal } from '../../global-structure/de-minimis/TreeStructureDeMinimisGlobal';
import { TreeStructureErklaerungGlobal } from '../../global-structure/erklaerung/TreeStructureErklaerungGlobal';
import { TreeStructureAntragFinanzierungsPlanGlobal } from '../../global-structure/finanzierung-plan-antrag/TreeStructureAntragFinanzierungsPlanGlobal';
import { TreeStructureSelbstErklaerungRUSGlobal } from '../../global-structure/rus-erklaerung/TreeStructureSelbstErklaerungRUSGlobal';
import { TreeStructureSelbstErklaerungKMUGlobal } from '../../global-structure/selbst-erklaerung-kmu/TreeStructureSelbstErklaerungKMUGlobal';
import { TreeStructureSelbstErklaerungBeihilferelevanzGlobal } from '../../global-structure/beihilferelevanz-erklaerung/TreeStructureSelbstErklaerungBeihilferelevanzGlobal';
import { TreeStructureAntragVerbundpartnerGlobal } from '../../global-structure/verbundpartner-antrag/TreeStructureAntragVerbundpartnerGlobal';
import { TreeStructureAntragVorzeitigerMassnahme } from '../../global-structure/vorzeitige-massnahme/TreeStructureVorzeitigeMassnahmeGlobal';
import { TreeStructureZeitplanungGlobal } from '../../global-structure/zeitplanung/TreeStructureZeitplanungGlobal';
import ProjektDatenAntragLoewe, { getFormStrucProjektDatenAntragLoewe } from './content/ProjektDatenAntragLoewe';
import EinnahmeUebersichtAntragLoewe from './content/einnahme/EinnahmeUebersichtAntragLoewe';
import { GetEigenmittelAntragLoewe } from './content/einnahme/GetEigenmittelAntragLoewe';
import { GetPersonalKostenAntragLoewe } from './content/personalkosten/GetPersonalKostenAntragLoewe';
import PersonalKostenUebersichtAntragLoewe from './content/personalkosten/PersonalKostenUebersichtAntragLoewe';
import AusgangssituationAntragLoewe, { getFormStrucAusgangssituationAntragLoewe } from './content/projektbeschreibung/AusgangssituationAntragLoewe';
import BeschreibungDesVorhabensAntragLoewe, {
	getFormStrucBeschreibungDesVorhabensAntragLoewe,
} from './content/projektbeschreibung/BeschreibungDesVorhabens';
import EffekteDesVorhabensAntragLoewe, {
	getFormStrucEffekteDesVorhabensAntragLoewe,
} from './content/projektbeschreibung/EffekteDesVorhabensAntragLoewe';
import MarktanalyseAntragLoewe, { getFormStrucMarktanalyseAntragLoewe } from './content/projektbeschreibung/MarktanalyseAntragLoewe';
import OrganisationUndMeilensteineAntragLoewe, {
	getFormStrucOrganisationUndMeilensteineAntragLoewe,
} from './content/projektbeschreibung/OrganisationUndMeilensteineAntragLoewe';
import StandortEffekteAntragLoewe, { getFormStrucStandortEffekteAntragLoewe } from './content/projektbeschreibung/StandortEffekteAntragLoewe';
import SwotAntragLoewe, { getFormStrucSwotAntragLoewe } from './content/projektbeschreibung/SwotAntragLoewe';
import { GetSachkostenAntragLoewe } from './content/sachkosten/GetSachkostenAntragLoewe';
import SachkostenUebersichtAntragLoewe from './content/sachkosten/SachkostenUebersichtAntragLoewe';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import VorbereitungFormantrag, { getFormStrucVorbereitungFormantrag } from './content/vorbereitung-formantrag/VorbereitungFormantrag';
const P = AntragSchema.attributes;

export const TreeStructureAntragLoewe = (
	application: any,
	kostenKategoriesGroup: any,
	readOnly: boolean,
	allgemeineHinweiseKMU: any,
	allgemeineHinweiseDeminimis: any,
	allgemeineHinweiseRUS: any,
	allgemeineHinweiseBeihilferelevanz: any,
): TreeNodeType[] => {
	const hasCommentProjektdaten = checkIfProjektDatenHasComment(readOnly, application);
	const isKostenEditable = checkIfAllPositionIsEditable(readOnly, application);
	const isFormantrag = get(application, P.Allgemein_Art_Des_Antrags.path) === ART_DES_ANTRAGS.Formantrag;

	let treeNodes: TreeNodeType[] =
		isFormantrag ?
			[
				// Allgemeine Hinweise Global
				...TreeStructureAllgemeinHinweisGlobal(application),
				// Projektdaten
				{
					label: 'Vorbereitung Formantrag',
					content: <VorbereitungFormantrag />,
					formStruc: getFormStrucVorbereitungFormantrag(application),
				},
				{
					label: 'Projektdaten',
					content: <ProjektDatenAntragLoewe hasComment={hasCommentProjektdaten} />,
					formStruc: getFormStrucProjektDatenAntragLoewe(application),
					hasComment: hasCommentProjektdaten,
				},
				// Antragsteller Global
				...TreeStructureAntragstellerGlobal(application, readOnly),
				// Verbundpartner Global
				...TreeStructureAntragVerbundpartnerGlobal(application, readOnly),
				// Zeitplanung Global
				...TreeStructureZeitplanungGlobal(application, readOnly),

				// Kosten
				...PersonalKostenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
				...SachKostenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
				...EinnahmeStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
				// Finanzierungplan Global
				...TreeStructureAntragFinanzierungsPlanGlobal(application, isKostenEditable),
				// Anlagen und Erklärungen Global
				...TreeStructureAnlagenGlobal(application, readOnly),
				...TreeStructureErklaerungGlobal(application, readOnly),
				// Abschluss Global
				...TreeStructureAntragAbschlussSeiteGlobal(application, readOnly),
			]
		:	[
				// Allgemeine Hinweise Global
				...TreeStructureAllgemeinHinweisGlobal(application),
				// Projektdaten
				{
					label: 'Projektdaten',
					content: <ProjektDatenAntragLoewe hasComment={hasCommentProjektdaten} />,
					formStruc: getFormStrucProjektDatenAntragLoewe(application),
					hasComment: hasCommentProjektdaten,
				},
				// Antragsteller Global
				...TreeStructureAntragstellerGlobal(application, readOnly),
				// Verbundpartner Global
				...TreeStructureAntragVerbundpartnerGlobal(application, readOnly),
				// Selbsterlärung-KMU Global
				...TreeStructureSelbstErklaerungKMUGlobal(application, readOnly, allgemeineHinweiseKMU),
				// Beihilferelevanz-Erklärungen Global
				...TreeStructureSelbstErklaerungBeihilferelevanzGlobal(application, readOnly, allgemeineHinweiseBeihilferelevanz),
				// RUS-Erklärungen Global
				...TreeStructureSelbstErklaerungRUSGlobal(application, readOnly, allgemeineHinweiseRUS),
				// Deminismis-Selbsterklärung Global
				...TreeStructureDeMinimisGlobal(application, readOnly, allgemeineHinweiseDeminimis),
				// Projektbeschreibung
				...ProjektBeschreibungStructure(application, readOnly),
				// Zeitplanung Global
				...TreeStructureZeitplanungGlobal(application, readOnly),
				// Kosten
				...PersonalKostenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
				...SachKostenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
				...EinnahmeStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
				// Finanzierungplan Global
				...TreeStructureAntragFinanzierungsPlanGlobal(application, isKostenEditable),
				// Anlagen und Erklärungen Global
				...TreeStructureAnlagenGlobal(application, readOnly),
				...TreeStructureErklaerungGlobal(application, readOnly),
				// Vorzeitiger Massnahme Global
				...TreeStructureAntragVorzeitigerMassnahme(application, readOnly),
				// Abschluss Global
				...TreeStructureAntragAbschlussSeiteGlobal(application, readOnly),
				// Bescheid Global
				...TreeStructureAntragBescheidGlobal(application),
			];

	return treeNodes;
};

const ProjektBeschreibungStructure = (application: any, readOnly: boolean) => {
	const hasCommentAusgangssituation = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Ausgangssituation_Pruefstatus.path,
	);
	const hasCommentBeschreibungDesVorhabens = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Pruefstatus.path,
	);
	const hasCommentMarktanalyse = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Marktanalyse_Pruefstatus.path,
	);
	const hasCommentEffekteDesVorhabens = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Pruefstatus.path,
	);
	const hasCommentSWOT = checkIfHasComment(readOnly, application, P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_SWOT_Pruefstatus.path);
	const hasCommentOrganisation = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Meilensteinplanung_Pruefstatus.path,
	);
	const hasCommentStandorteffekte = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Transfer_Pruefstatus.path,
	);
	let nodes: TreeNodeType[] = [
		{
			label: 'Projektbeschreibung',
			content: <ApplicationHeading title='Projektbeschreibung' description={PLATZHALTER_TEXT} />,
			hasComment:
				(
					hasCommentAusgangssituation ||
					hasCommentBeschreibungDesVorhabens ||
					hasCommentMarktanalyse ||
					hasCommentEffekteDesVorhabens ||
					hasCommentSWOT ||
					hasCommentOrganisation ||
					hasCommentStandorteffekte
				) ?
					true
				:	false,
			children: [
				{
					label: 'Ausgangssituation',
					content: <AusgangssituationAntragLoewe hasComment={hasCommentAusgangssituation} />,
					formStruc: getFormStrucAusgangssituationAntragLoewe(application),
					hasComment: hasCommentAusgangssituation,
				},
				{
					label: 'Beschreibung des Vorhabens',
					content: <BeschreibungDesVorhabensAntragLoewe hasComment={hasCommentBeschreibungDesVorhabens} />,
					formStruc: getFormStrucBeschreibungDesVorhabensAntragLoewe(application),
					hasComment: hasCommentBeschreibungDesVorhabens,
				},
				{
					label: 'Marktanalyse',
					content: <MarktanalyseAntragLoewe hasComment={hasCommentMarktanalyse} />,
					formStruc: getFormStrucMarktanalyseAntragLoewe(application),
					hasComment: hasCommentMarktanalyse,
				},
				{
					label: 'Effekte des Vorhabens',
					content: <EffekteDesVorhabensAntragLoewe hasComment={hasCommentEffekteDesVorhabens} />,
					formStruc: getFormStrucEffekteDesVorhabensAntragLoewe(application),
					hasComment: hasCommentEffekteDesVorhabens,
				},
				{
					label: 'SWOT',
					content: <SwotAntragLoewe hasComment={hasCommentSWOT} />,
					formStruc: getFormStrucSwotAntragLoewe(application),
					hasComment: hasCommentSWOT,
				},
				{
					label: 'Organisation',
					content: <OrganisationUndMeilensteineAntragLoewe hasComment={hasCommentOrganisation} />,
					formStruc: getFormStrucOrganisationUndMeilensteineAntragLoewe(application),
					hasComment: hasCommentOrganisation,
				},
				{
					label: 'Standorteffekte',
					content: <StandortEffekteAntragLoewe hasComment={hasCommentStandorteffekte} />,
					formStruc: getFormStrucStandortEffekteAntragLoewe(application),
					hasComment: hasCommentStandorteffekte,
				},
			],
		},
	];
	return nodes;
};
const PersonalKostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	let nodes: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Personalkosten)) {
		nodes = [
			{
				label: 'Personalausgaben',
				content: <ApplicationHeading title='Personalausgaben' description={PLATZHALTER_TEXT} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Personalkosten),
				children: GetPersonalKostenAntragLoewe(application, hasCommentAusgabenUndFinanzierung),
			},
			{
				label: 'Personalausgaben Übersicht',
				content: <PersonalKostenUebersichtAntragLoewe />,
				isSummaryReport: true,
			},
		];
	}
	return nodes;
};
const SachKostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	let nodes: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Sachkosten)) {
		nodes = [
			{
				label: 'Sachausgaben',
				content: <ApplicationHeading title='Sachausgaben' description={PLATZHALTER_TEXT} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Sachkosten),
				children: GetSachkostenAntragLoewe(application, hasCommentAusgabenUndFinanzierung),
			},
			{
				label: 'Sachausgaben Übersicht',
				content: <SachkostenUebersichtAntragLoewe />,
				isSummaryReport: true,
			},
		];
	}
	return nodes;
};
const EinnahmeStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	let nodes: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Einnahme, []).includes(KOSTEN_ARTEN.Eigenmittel)) {
		nodes = [
			{
				label: 'Eigen- und Drittmittel',
				content: <ApplicationHeading title='Eigen- und Drittmittel' description={PLATZHALTER_TEXT} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Eigenmittel),
				children: GetEigenmittelAntragLoewe(application, hasCommentAusgabenUndFinanzierung),
			},
			{
				label: 'Eigen- und Drittmittel Übersicht',
				content: <EinnahmeUebersichtAntragLoewe />,
				isSummaryReport: true,
			},
		];
	}
	return nodes;
};
